export interface AnnualEIT105000List {
    row?: string,
    name?: string,
    amount?: string,
    indent?: number,
    rowspan?: number,
    isEdit?: boolean,
    isEdit2?: boolean,
    isEdit3?: boolean,
    isEdit4?: boolean,
    type?: string,
    accountRecordAmount?: string,
    taxAmount?: string,
    increaseAmount?: string,
    reduceAmount?: string,
    accountBookId?:number | null,
    id?:number | null
}

let list: AnnualEIT105000List[] = [
    {
        name: "一、收入类调整项目（2+3+…8+10+11）",
        row: "1",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（一）视同销售收入（填写A105010）",
        row: "2",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（二）未按权责发生制原则确认的收入（填写A105020）",
        row: "3",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（三）投资收益（填写A105030）",
        row: "4",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（四）按权益法核算长期股权投资对初始投资成本调整确认收益",
        row: "5",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（五）交易性金融资产初始投资调整",
        row: "6",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（六）公允价值变动净损益",
        row: "7",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（七）不征税收入",
        row: "8",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "其中：专项用途财政性资金（填写A105040）",
        row: "9",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（八）销售折扣、折让和退回",
        row: "10",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（九）其他",
        row: "11",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "二、扣除类调整项目（13+14+…24+26+27+28+29+30）",
        row: "12",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（一）视同销售成本（填写A105010）",
        row: "13",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: false,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（二）职工薪酬（填写A105050）",
        row: "14",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（三）业务招待费支出",
        row: "15",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（四）广告费和业务宣传费支出（填写A105060）",
        row: "16",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（五）捐赠支出（填写A105070）",
        row: "17",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（六）利息支出",
        row: "18",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（七）罚金、罚款和被没收财物的损失",
        row: "19",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（八）税收滞纳金、加收利息",
        row: "20",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（九）赞助支出",
        row: "21",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（十）与未实现融资收益相关在当期确认的财务费用",
        row: "22",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（十一）佣金和手续费支出",
        row: "23",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（十二）不征税收入用于支出所形成的费用",
        row: "24",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "其中：专项用途财政性资金用于支出所形成的费用（填写A105040）",
        row: "25",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（十三）跨期扣除项目",
        row: "26",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（十四）与取得收入无关的支出",
        row: "27",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（十五）境外所得分摊的共同支出",
        row: "28",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（十六）党组织工作经费",
        row: "29",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（十七）其他",
        row: "30",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "三、资产类调整项目（32+33+34+35）",
        row: "31",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（一）资产折旧、摊销（填写A105080）",
        row: "32",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（二）资产减值准备金",
        row: "33",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（三）资产损失（填写A105090）",
        row: "34",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（四）其他",
        row: "35",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "四、特殊事项调整项目（37+38+…+42）",
        row: "36",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        id:null,
        accountBookId:null
    },
    {
        name: "（一）企业重组及递延纳税事项（填写A105100）",
        row: "37",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（二）政策性搬迁（填写A105110）",
        row: "38",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },

    {
        name: "（三）特殊行业准备金（填写A105120）",
        row: "39",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（四）房地产开发企业特定业务计算的纳税调整额(填写A105010)",
        row: "40",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（五）有限合伙企业法人合伙方应分得的应纳税所得额",
        row: "41",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "（六）其他",
        row: "42",
        amount: "",
        indent: 2,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "五、特别纳税调整应税所得",
        row: "43",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "六、其他",
        row: "44",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        id:null,
        accountBookId:null
    },
    {
        name: "合计（1+12+31+36+43+44）",
        row: "45",
        amount: "",
        indent: 0,
        accountRecordAmount: "",
        taxAmount: "",
        increaseAmount: "",
        reduceAmount: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        id:null,
        accountBookId:null
    },


]


let AnnualEIT105000 = list
export default AnnualEIT105000
